import { createStyles, makeStyles, Theme } from '@material-ui/core'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0 12px 12px'
    },
    logo: {
      marginTop: '20px',
      width: '160px'
    },
    success: {
      width: '200px'
    },
    mailIllustration: {
      width: '64px',
      marginBottom: '10px',
    },
    nextHeavyHardware: {
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      color: '#A5965A',
      fontSize: 28,
      textAlign: 'center',
    },
    nextArt: {
      fontFamily: 'OutfitHeavy',
      textTransform: 'uppercase',
      fontSize: 16,
      textAlign: 'center',
    },
    header: {
      fontFamily: 'Lato',
      fontSize: '18px',
      //paddingBottom: '12px',
      '& > span': {
        color: 'var(--bosscat-blue-600)'
      },
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    desc: {
      fontFamily: 'Lato',
      maxWidth: '360px',
      fontSize: '18px',
      lineHeight: '27px',
      textAlign: 'center',
      //color: 'rgba(73, 74, 90, 1)'
    },
    desc2: {
      fontFamily: 'LatoNormal',
      textAlign: 'center',
      maxWidth: '360px',
      fontSize: '16px',
      lineHeight: '24px',
      color: 'rgba(73, 74, 90, 1)'
    },
    descLink: {
      fontFamily: 'Lato',
      fontWeight: 700,
      //maxWidth: '360px',
      fontSize: '18px',
      lineHeight: '24px',
      color: '#2F7BF7',
      textAlign: 'center',
      textDecoration: 'underline',
    },
    ask: {
      paddingBottom: '4px'
    },
    button: {
      height: '58px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-blue-600)',
      borderRadius: 8,
      marginTop: '20px',
      marginBottom: '10px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    emailButton: {
      height: '50px',
      width: '340px',
      textTransform: 'none',
      backgroundColor: 'var(--white-color)',
      borderRadius: 8,
      marginTop: '20px',
      marginBottom: '10px',
      marginLeft: 'auto',
      marginRight: 'auto',
      fontFamily: 'Lato',
      fontSize: '18px',
      lineHeight: '24px',
    },
    emailImg: {
      height: '16px',
    },


    estimatedTimeContainer: {
      display: 'flex',
      marginTop: '2rem',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        margin: '1rem'
      }
    },
    estimatedTimeItem: {
      display: 'flex',
      flexDirection: 'column',
      width: '220px',
      [theme.breakpoints.down('md')]: {
        width: '196px'
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    estimatedTimeLabel: {
      fontFamily: 'Lato',
      fontSize: '18px',
      lineHeight: '28px',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    estimatedTimeDate: {
      fontSize: '20px',
      lineHeight: '30px'
    },
    estimatedTime: {
      textAlign: 'center',
      borderWidth: '2px',
      borderRadius: '8px',
      padding: '8px 16px',
      margin: '8px 0px',
      borderStyle: 'solid',
      borderColor: theme.palette.grey[700],
      backgroundColor: 'var(--white-color)',
      color: theme.palette.grey[700],
      width: '220px',
      [theme.breakpoints.down('md')]: {
        width: '196px'
      }
    },
    dashedSeparator: {
      width: '128px',
      [theme.breakpoints.down('md')]: {
        width: '96px'
      },
      [theme.breakpoints.down('sm')]: {
        width: '46px',
        transform: 'rotate(90deg)',
        margin: 18
      },
      border: '2px dashed #AAACBB',
      alignSelf: 'center',
      borderWidth: '0px',
      borderTopWidth: '2px',
      borderColor: theme.palette.grey[400],
      margin: '60px 24px 40px'
    },
    borderBlue: {
      borderColor: theme.palette.primary.light,
      color: theme.palette.primary.light
    },
    expedite: {
      position: 'relative',
      width: '100%',
      maxWidth: '650px',
      display: 'flex',
      alignItems: 'center',
      background: 'rgba(249, 250, 250, 1)',
      borderRadius: '8px',
      padding: '12px 16px',
      justifyContent: 'space-between',
      margin: '12px 0'
    },
    expediteButton: {
      width: '220px',
      height: '48px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-green-600)',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: 'var(--bosscat-green-700) !important'
      }
    },
    sooner: {
      position: 'absolute',
      top: '-12px',
      fontFamily: 'LatoNormal',
      fontSize: '16px',
      borderRadius: '8px',
      lineHeight: '24px',
      fontWeight: 500,
      textAlign: 'center',
      color: 'var(--hardware-haze-600)',
      backgroundColor: 'var(--scheduling-color-back)',
      padding: '4px 8px',
      [theme.breakpoints.down('sm')]: {
        top: '-16px'
      }
    },
    icon: {
      width: '72px',
      height: '72px'
    },
    createAccount: {
      width: '100%',
      maxWidth: '650px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '8px',
      margin: '8px 0',
      justifyContent: 'space-around',
      border: '2px solid #0071A3',
      padding: '8px'
    },
    createButton: {
      width: '250px',
      float: 'right',
      height: '50px',
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-blue-600)',
      borderRadius: 8,
      fontSize: '14px',
      margin: '5px',
      lineHeight: '1.2',
      [theme.breakpoints.down('sm')]: {
        margin: '2px',
      }
    },
    videoText: {
      marginTop: '8px'
    },
    video: {
      border: '1px solid var(--gray-color)',
      padding: '4px',
      margin: '8px 0',
      borderRadius: '16px',
      maxWidth: '650px',
      width: '100%',
      height: '300px'
    },
    completeProfile: {
      width: '100%',
      maxWidth: '650px',
      display: 'flex',
      justifyContent: 'space-around',
      gap: '1rem',
      background: '#FAFDFF',
      border: '2px solid #0071A3',
      borderRadius: 16,
      padding: '.7rem',
      alignItems: 'center',
      margin: '2rem 0',
      [theme.breakpoints.down('sm')]: {
        gap: '0',
        margin: '8px 0',
        padding: '8px'
      }
    },
    bold: {
      fontWeight: 'bold',
    },
    grid: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    letsLogin: {
      width: '100%',
      maxWidth: '361px',
      display: 'flex',
      justifyContent: 'center',
      // gap: '1rem',
      background: '#F6F5EF',
      //border: '2px solid #0071A3',
      borderRadius: 16,
      padding: '.7rem',
      alignItems: 'center',
      margin: '2rem 0',
      [theme.breakpoints.down('sm')]: {
        gap: '0',
        margin: '8px 0',
        padding: '8px'
      }
    },
  })
)
